import { render, staticRenderFns } from "./analisis-colegios.vue?vue&type=template&id=a6cedade"
import script from "./analisis-colegios.vue?vue&type=script&lang=js"
export * from "./analisis-colegios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports